import React, { useState } from 'react';
import ContentCNReports from './componenents/CareNavigatorReports/ContentCNReports';
import './componenents/CareNavigatorReports/CareNavigatorReports.css';

function CareNavigatorReports() {

  return (
    <>
      <ContentCNReports />
    </>
  );
}

export default CareNavigatorReports;
